module.exports = __webpack_public_path__ + "img/p77.afd583f2.png";